import FormSwitchSet from './FormCheckboxSet';

export default FormSwitchSet;
